var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBotebasura18Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aaafba;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.67,15.42c.41,0,.74-.33,.74-.74v-5.96c0-.41-.33-.74-.74-.74s-.74,.33-.74,.74v5.96c0,.41,.33,.74,.74,.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.19,15.42c.41,0,.74-.33,.74-.74v-5.96c0-.41-.33-.74-.74-.74s-.74,.33-.74,.74v5.96c0,.41,.33,.74,.74,.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,15.42c.41,0,.74-.33,.74-.74v-5.96c0-.41-.33-.74-.74-.74s-.74,.33-.74,.74v5.96c0,.41,.33,.74,.74,.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.67,2.46h-3c.01-.05,.03-.1,.03-.15V.79c0-.41-.33-.74-.74-.74H5.98c-.41,0-.74,.33-.74,.74v1.52c0,.05,.02,.1,.03,.15H2.33C1.04,2.46,0,3.51,0,4.79v1.31c0,.41,.33,.74,.74,.74h.72l.6,8.32c.11,1.61,1.46,2.87,3.07,2.87h7.72c1.62,0,2.97-1.27,3.07-2.88l.55-8.31h.78c.41,0,.74-.33,.74-.74v-1.31c0-1.28-1.04-2.33-2.33-2.33Zm-1.22,12.59c-.05,.84-.75,1.49-1.59,1.49H5.14c-.83,0-1.53-.65-1.59-1.49l-.58-8.04H14.98s-.53,8.04-.53,8.04ZM6.72,2.31v-.78h4.51v.78c0,.05,.02,.1,.03,.15H6.69c.01-.05,.03-.1,.03-.15Zm9.8,3.05H1.48v-.57c0-.46,.38-.84,.84-.84H15.67c.46,0,.84,.38,.84,.84v.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBotebasura18Px);
export default __webpack_public_path__ + "static/media/icon_botebasura18px.4b9297275c2d676cb7e71099ba7a45f6.svg";
export { ForwardRef as ReactComponent };